import React from "react";
import Slider from "react-slick";
import "./App.css"; // shared default styles
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Reusablemulti = ({ items }) => {
    const settings  = {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              fade: false,
              arrows:false
            },
          },
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              fade: false,
            },
          },
        ],
        };

return (
    <>
<Slider {...settings}>
      {items.map((item, index) => (
        <div key={index}>
          <div className="slider-content"> 
            {item.image && (
              <img src={item.image} className="img-fluid ro-access"/>
            )}
            <h3>{item.title}</h3>
            <p>{item.content}</p>
          </div>
        </div>
      ))}
    </Slider>
    </>
);
}
export default Reusablemulti;